import { useMutation } from '@apollo/client';
import React from 'react';

import { Button, Popup, PopupSection, Text } from '@flixbus/honeycomb-react';

import { Portal } from 'common';
import { standardDeletedSuccess } from 'global/commonMessages';
import { notificationStore } from 'global/NotificationStore';
import { crewMemberActionLogStore } from 'pages/CrewMemberDetails/components/CrewMemberActionLog/CrewMemberActionLogStore';
import { crewMemberDetailsStore } from 'pages/CrewMemberDetails/crewMemberDetailsStore';
import { DELETE_CREW_MEMBER_HOLD_DOWN } from 'pages/CrewMemberDetails/gql/deleteCrewMemberHoldDown';
import { handleError } from 'utils/error-parser';

import { DELETE_REPLACEMENT_TEXT } from './text';

const DeleteReplacement = ({ holdDownId, onClose }) => {
	const [deleteCrewMemberHoldDown, { loading: isDeleting }] = useMutation(
		DELETE_CREW_MEMBER_HOLD_DOWN,
		{ fetchPolicy: 'network-only' }
	);

	const handleDeleteReplacement = async () => {
		if (!holdDownId) {
			handleError(new Error('Hold down ID is missing.'));
			return;
		}

		try {
			const { data } = await deleteCrewMemberHoldDown({ variables: { id: holdDownId } });
			const { errors: mutationErrors = [] } = data?.deleteCrewMemberHoldDown ?? {};

			if (mutationErrors.length) {
				handleError(mutationErrors);
				return;
			}

			notificationStore.setNotification(standardDeletedSuccess);
			crewMemberActionLogStore.fetchLog();
			await crewMemberDetailsStore.fetchAll();
			onClose();
		} catch (error) {
			handleError(error);
		}
	};

	return (
		<Portal>
			<Popup active id="modal-delete-replacement" onOverlayClick={onClose}>
				<PopupSection type="title">{DELETE_REPLACEMENT_TEXT.title}</PopupSection>
				<PopupSection type="content">
					<Text>{DELETE_REPLACEMENT_TEXT.content}</Text>
				</PopupSection>
				<PopupSection type="actions">
					<Button type="button" onClick={onClose}>
						{DELETE_REPLACEMENT_TEXT.cancelButton}
					</Button>
					<Button
						type="button"
						appearance="danger"
						disabled={isDeleting}
						onClick={handleDeleteReplacement}
					>
						<strong>{DELETE_REPLACEMENT_TEXT.confirmButton}</strong>
					</Button>
				</PopupSection>
			</Popup>
		</Portal>
	);
};

export default DeleteReplacement;
